import Layout from "@/layoutPlus/Container.vue"
import { clear, getStorage } from "../storage"
import router from "@/router"
import Router from "vue-router"

export const commonRouter = [
  {
    path: '/',
    redirect: '/enterprise'
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: "登录",
    },
    component: () => import("@/views/loginPlus/login")
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: "消息中心",
      icon: require('@/assets/img/nav/aside1.png'),
      iconActive: require('@/assets/img/nav/aside1active.png'),
    },
    component: Layout,
    children: [
      {
        path: '/home',
        name: 'HomeBanner',
        meta: {
          title: '消息中心'
        },
        component: () => import("@/views/homePlus/banner")
      },
    ]
  },
  {
    path: "/postManagement",
    name: "postManagement",
    meta: {
      title: "岗位管理",
      icon: require('@/assets/img/nav/aside2.png'),
      iconActive: require('@/assets/img/nav/aside2active.png'),
    },
    component: Layout,
    children: [
      {
        path: "/postManagement",
        name: "postManagement",
        meta: {
          title: "岗位管理"
        },
        component: () => import("@/views/postManagement/index"),
      }
    ]
  },
  {
    path: "/partTimeJobment",
    name: "partTimeJobment",
    meta: {
      title: "兼职管理",
      icon: require('@/assets/img/nav/aside2.png'),
      iconActive: require('@/assets/img/nav/aside2active.png'),
    },
    component: Layout,
    children: [
      {
        path: "/partTimeJobment",
        name: "partTimeJobment",
        meta: {
          title: "兼职管理"
        },
        component: () => import("@/views/partTimeJobment/index"),
      }
    ]
  },
  {
    path: "/resumeManagement",
    name: "resumeManagement",
    meta: {
      title: "简历管理",
      icon: require('@/assets/img/nav/aside3.png'),
      iconActive: require('@/assets/img/nav/aside3active.png'),
    },
    component: Layout,
    children: [
      {
        path: "/resumeManagement",
        name: "resumeManagement",
        meta: {
          title: "简历管理"
        },
        component: () => import("@/views/resumeManagement/index"),
      }
    ]
  },
  {
    path: "/talentRecommendation",
    name: "talentRecommendation",
    meta: {
      title: "人才推荐",
      icon: require('@/assets/img/nav/aside4.png'),
      iconActive: require('@/assets/img/nav/aside4active.png'),
    },
    component: Layout,
    children: [
      {
        path: "/talentRecommendation",
        name: "talentRecommendation",
        meta: {
          title: "人才推荐"
        },
        component: () => import("@/views/talentRecommendation/index"),
      }
    ]
  },
  {
    path: "/accountCenter",
    name: "accountCenter",
    meta: {
      title: "账户中心",
      icon: require('@/assets/img/nav/aside5.png'),
      iconActive: require('@/assets/img/nav/aside5active.png'),
    },
    component: Layout,
    children: [
      {
        path: "/accountCenter",
        name: "accountCenter",
        meta: {
          title: "账户中心"
        },
        component: () => import("@/views/accountCenter/index"),
      }
    ]
  },
  {
    path: "/enterprise",
    name: "enterprise",
    meta: {
      title: "企业信息",
      icon: require('@/assets/img/nav/aside6.png'),
      iconActive: require('@/assets/img/nav/aside6active.png'),
    },
    component: Layout,
    children: [
      {
        path: "/enterprise",
        name: "enterprise",
        meta: {
          title: "企业信息"
        },
        component: () => import("@/views/enterprise/index"),
      }
    ]
  },
  {
    path: "/addressManagement",
    name: "addressManagement",
    meta: {
      title: "地址管理",
      icon: require('@/assets/img/nav/aside4.png'),
      iconActive: require('@/assets/img/nav/aside4active.png'),
    },
    component: Layout,
    children: [
      {
        path: "/addressManagement",
        name: "addressManagement",
        meta: {
          title: "地址管理"
        },
        component: () => import("@/views/addressManagement/index"),
      }
    ]
  },
  {
    path: "/accountManagement",
    name: "accountManagement",
    meta: {
      title: "账号管理",
      icon: require('@/assets/img/nav/aside7.png'),
      iconActive: require('@/assets/img/nav/aside7active.png'),
    },
    component: Layout,
    children: [
      {
        path: "/accountManagement",
        name: "accountManagement",
        meta: {
          title: "账号管理"
        },
        component: () => import("@/views/accountManagement/index"),
      }
    ]
  },
  {
    path: "/invites",
    name: "invites",
    meta: {
      title: "我的邀请",
      icon: require('@/assets/img/nav/aside8.png'),
      iconActive: require('@/assets/img/nav/aside8active.png'),
    },
    component: Layout,
    children: [
      {
        path: "/invites",
        name: "invites",
        meta: {
          title: "我的邀请"
        },
        component: () => import("@/views/invites/index"),
      }
    ]
  },
  {
    path: '*',
    name: '404',
    meta: {
      title: '404',
    },
    component: () => import("@/views/404")
  }
]
function importComponent(arr) {
  arr.forEach(item => {
    if (!!item.children) {
      item.component = Layout
      if (!!item.children.length) {
        item.redirect = item.children[0].path
        importComponent(item.children)
      }
    } else {
      item.component = () => import(`@/views${item.path}`)
    }
  });
}


//生成动态路由
export function initRouter() {
  // const roleRouter = getStorage("router")
  const roleRouter = [];
  if (roleRouter) {
    console.log(roleRouter, 'roleRouterroleRouter')
    importComponent(roleRouter)
    commonRouter.splice(3, 0, ...roleRouter)
    router.matcher = new Router({
      mode: 'history',
      routes: commonRouter,
    }).matcher
  } else {
    clear()
    router.replace("/login")
  }
}